import log from 'salvo-lite/log'
import axios from 'axios'

class Variants {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._input = elem.querySelector('[name="id"]')
        this._selects = elem.querySelectorAll('select')
        this._variants = JSON.parse(elem.getAttribute('data-variants'))
        this._button = document.querySelector('[data-cart-button]')
        this._currency = document.querySelector('select.currency-input')
        log.debug(this.constructor.name, 'Constructed', this)
    }
    onInit () {
        this._selects.forEach(select => {
            select.addEventListener('change', e => {
                this._elem.classList.add('working')
                this._options(select)
            })
        })
        this._currency.addEventListener('makeChange', e => {
            const currency = this._currency.value
            this._currency.value = 'GBP'
            const evt = new Event('change')
            this._currency.dispatchEvent(evt)
            this._currency.value = currency
            this._currency.dispatchEvent(evt)
        })
    }
    _options (select) {
        let options = []
        switch (select.name) {
        case 'option1':
            if (this._selects[2]) {
                this._selects[2].setAttribute('disabled', '')
            }
            this._variants.forEach(variant => {
                if (variant.option1 === select.value) {
                    if (!options.includes(variant.option2)) {
                        options.push(variant.option2)
                    }
                }
            })
            this._createOptions(this._selects[1], options)
            if (this._selects[2]) {
                this._variants.forEach(variant => {
                    if (variant.option2 === select.value && variant.option1 === this._selects[0].value) {
                        if (!options.includes(variant.option3)) {
                            options.push(variant.option3)
                        }
                    }
                })
                this._createOptions(this._selects[2], options)
            }
            break
        case 'option2':
            this._variants.forEach(variant => {
                if (variant.option2 === select.value && variant.option1 === this._selects[0].value) {
                    if (!options.includes(variant.option3)) {
                        options.push(variant.option3)
                    }
                }
            })
            this._createOptions(this._selects[2], options)
            break
        case 'option3':
            this._checkVariant()
            break
        }
    }
    _createOptions (select, options) {
        if (select) {
            let html = '<option placeholder selected value="">' + select.getAttribute('data-name') + '</option>'
            options.forEach(option => {
                html += '<option value="' + option + '">' + option + '</option>'
            })
            select.innerHTML = html
            select.removeAttribute('disabled')
        }
        this._checkVariant()
    }
    _checkVariant () {
        let variantTitle = ''
        this._selects.forEach(select => {
            variantTitle += select.value + ' / '
        })
        variantTitle = variantTitle.slice(0, -3)
        let variant = ''
        let variantObj = ''
        this._variants.forEach(variantOpt => {
            if (variantOpt.title === variantTitle) {
                variant = variantOpt.id
                variantObj = variantOpt
            }
        })
        if (variant) {
            this._updateUrl(variant)
            this._updateInput(variantObj)
        } else {
            let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname
            window.history.replaceState({ path: newurl }, '', newurl)
            this._updateInput(' ')
        }
        this._updateButton(variantObj)
    }
    _updateButton (variant) {
        if (variant.available) {
            this._button.textContent = this._button.getAttribute('data-cart-button-add')
            this._button.removeAttribute('disabled')
        } else if (variant) {
            this._button.textContent = this._button.getAttribute('data-cart-button-sold-out')
            this._button.setAttribute('disabled', '')
        } else {
            this._button.textContent = this._button.getAttribute('data-selection')
            this._button.setAttribute('disabled', '')
        }
        this._elem.classList.remove('working')
    }
    _updateUrl (id) {
        let newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + id
        window.history.replaceState({ path: newurl }, '', newurl)
        this._elem.classList.remove('working')
    }
    _updateInput (variant) {
        this._input.value = variant.id
        if (variant.price) {
            axios.get(window.location.pathname + '?variant=' + variant.id).then((response) => {
                const productPageContent = document.createElement('div')
                productPageContent.innerHTML = response.data
                const newPrice = productPageContent.querySelector('.price-wrapper').innerHTML
                this._updatePrice(newPrice)
            }).then((response) => {
                const evt = new Event('makeChange')
                this._currency.dispatchEvent(evt)
            })
        }
    }
    _updatePrice (price) {
        document.querySelector('.price-wrapper').innerHTML = price
        console.log('price')
    }
}

export default Variants



// WEBPACK FOOTER //
// ./src/resources/scripts/components/Variants.js